module.exports = __webpack_public_path__ + "img/title-bg.471c84a3.png";